function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.98197 8.57801C5.43197 6.68401 5.87297 4.78901 6.33897 2.89901C6.64797 1.65001 7.15397 1.30601 8.37797 1.59901C10.908 2.20401 13.429 2.84601 15.948 3.49701C17.017 3.77401 17.378 4.38201 17.126 5.46601C16.203 9.39001 15.269 13.308 14.321 17.225C14.071 18.26 13.483 18.642 12.469 18.397C9.84497 17.765 7.22497 17.103 4.61097 16.425C3.63797 16.173 3.33297 15.57 3.58697 14.458C4.03497 12.495 4.51497 10.538 4.98197 8.57801Z",
  fill: "#9F9F32"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.28001 12.61C8.73101 10.716 9.17101 8.81899 9.63701 6.92999C9.94601 5.68099 10.452 5.33599 11.676 5.62999C14.205 6.23499 16.727 6.87699 19.244 7.52899C20.313 7.80599 20.677 8.41199 20.421 9.49899C19.501 13.422 18.566 17.34 17.617 21.257C17.367 22.292 16.781 22.674 15.766 22.428C13.141 21.796 10.522 21.135 7.90601 20.457C6.93501 20.205 6.62901 19.603 6.88301 18.49C7.33301 16.526 7.81301 14.569 8.28001 12.61Z",
  fill: "#F5F500"
});

var SvgYellowcards = function SvgYellowcards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowcards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellowcards.08f53d58.svg";
export { ForwardRef as ReactComponent };